export const isNotContain = (currentUser, permission) => {
  return !currentUser?.authorities?.includes(permission);
};
